import * as React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import './accordcareer.css';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';



export default function AccordCareer() {
    const [expanded, setExpanded] = React.useState(false);
  
    const handleChange = (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
    };
    return (
      <div className='accordcareer' >
        {/*------------------- show more less ------------------*/}
          <div  style={{backgroundColor:'#F1F1F1'}} className='show__container'>
            <div  className="showb-1-main">
            <input type="checkbox" id='check' />
            <div className="subshow">
               
                  <div className="subshow-1">
                      <div className='role__head'>Mechanical Engineering Intern</div>
                      
                        <div className='loc'><b>Location</b>: Work from Anywhere </div>
                        <div className='ex'><b>Experience</b>: 0-1 year </div>
                    </div>
                    <div  className="subshow-2">
                      <p><b>Date Posted</b>:<span>Jul 15,2022</span></p>
                      <a href="https://forms.gle/weZsTb2tdYV3K1xs7" target='_blank'><button style={{cursor:'pointer'}} className='apply'>Apply</button></a>
                    </div>
              </div>
                  <div className="show__content">
                  <p><b> Responsibilities </b></p>
                 
                 <div>- Prepare the calculation each during the product design & development stages.</div>
                  <div>- Proper documentation of completed work.</div>
                  <div>- Taking the initiatives during each stage of development.</div>
                  <div>- You will be managing vendors.</div>
                  <div>- You will be contributing your time in designing by using CAD Designing Software (Preferable Fusion 360).</div>
                  <div>- You will also work on managing procurement.</div>
                  <div>- You will be Assisting our Technical Team. </div>
  
                  
                   <p><b>Other Skills</b> </p>

                  <div>- Fluency in English and Local Language.</div> 
                  <div>- Good Communication Skills both written and verbal.</div> 
                  <div>- Time Management Skills.</div> 
                  <div>- Ability to accept radical decisions.</div> 
                  <div>- Should be a quick learner.</div> 
                  
                  <p><b>Qualifications</b> </p>
                  
                  <div>- Graduated Bachelor's Degree (B.E/B.Tech) in Mechanical engineering or equivalent qualification.</div>
                  <div>- Experience in using CAD Software (preferable Fusion 360).</div>
                  <div>- Willingness to learn quickly in a self-paced training program.</div>
                  <div>- Ability to read and draw mechanical drawings.</div>
                  <div>- Knowledge in Manufacturing</div>
  
                 <p><b>Benefits</b> </p>
  
                  <div>- Work from anywhere.</div>
                  <div>- Get profit % in this project.</div>
                  <div>- You can work part-time, if you are associated with other organisation fulltime.</div>
                  <div>- Work with true innovators.</div>
  
                  <p><b>About Us</b>  </p>
                  
                 <div>Project Untouched is initiative of soaron.</div>
  
                  <div>We develop innovative touchless products of the future that solves mankind's problems.</div> 
                   
                  </div>
                  
            <label htmlFor="check">Read more</label>
            </div>
          </div>
        {/* 2 */}
          <div  style={{backgroundColor:''}} className='show__container'>
            <div  className="showb-1">
            <input type="checkbox" id='check2' />
            <div className="subshow">
               
                  <div className="subshow-1">
                  <div className='role__head'>Electronics Engineer Intern</div>
                  
                    <div className='__loc'><b>Location</b>: Work from Anywhere </div>
                    <div className='ex'><b>Experience</b>: 0-1 year </div>
                    </div>
                    <div className="subshow-2">
                      <p><b>Date Posted</b>: <span>Jul 15,2022</span></p>
                      <a href="https://forms.gle/weZsTb2tdYV3K1xs7" target='_blank'><button  style={{cursor:'pointer'}} className='apply'>Apply</button></a>
                    </div>
              </div>
                  <div className="show__content">
                 <b> <p> Responsibilities </p> </b>
                 
               <div>- Prepare the calculation each during the product design & development stages.</div>
                <div>- Proper documentation of completed work.</div>
                <div>- Taking the initiatives during each stage of development.</div>
                <div>- You will be managing vendors.</div>
                <div>- You will be contributing your time in designing by using CAD Designing Software (Preferable Fusion 360).</div>
                <div>- You will also work on managing procurement.</div>
                <div>- You will be Assisting our Technical Team. </div>

                 <b><p>Other Skills</p> </b>

                <div>- Fluency in English and Local Language.</div> 
                <div>- Good Communication Skills both written and verbal.</div> 
                <div>- Time Management Skills.</div> 
                <div>- Ability to accept radical decisions.</div> 
                <div>- Should be a quick learner.</div> 

                <b><p>Qualifications</p>  </b>

                <div>- Graduated Bachelor's Degree (B.E/B.Tech) in Mechanical engineering or equivalent qualification.</div>
                <div>- Experience in using CAD Software (preferable Fusion 360).</div>
                <div>- Willingness to learn quickly in a self-paced training program.</div>
                <div>- Ability to read and draw mechanical drawings.</div>
                <div>- Knowledge in Manufacturing</div>

                <b><p>Benefits</p></b>

                <div>- Work from anywhere.</div>
                <div>- Get profit % in this project.</div>
                <div>- You can work part-time, if you are associated with other organisation fulltime.</div>
                <div>- Work with true innovators.</div>

                 <b><p>About Us</p></b>
                
               <div>Project Untouched is initiative of soaron.</div>

                <div>We develop innovative touchless products of the future that solves mankind's problems.</div> 
                
                   
                  
              </div>
            <label htmlFor="check2">Read more</label>
            </div>
          </div>

        {/* 3rd */}


        <div  style={{backgroundColor:'#F1F1F1'}} className='show__container'>
            <div className="showb-1">
            <input type="checkbox" id='check3' />
            <div className="subshow">
               
                  <div className="subshow-1">
                  <div className='role__head'>Design Engineer (Plastics)</div>
                  
                    <div className='__loc'><b>Location</b>: Work from Anywhere </div>
                    <div className='ex'><b>Experience</b>: 0-1 year </div>
                    </div>
                    <div className="subshow-2">
                      <p><b>Date Posted</b>: <span>Jul 15,2022</span></p>
                      <a href="https://forms.gle/weZsTb2tdYV3K1xs7" target='_blank'><button  style={{cursor:'pointer'}} className='apply'>Apply</button></a>
                    </div>
              </div>
                  <div className="show__content">
                 <b> <p>Responsibilities</p>  </b>

              <div>- Plastic parts modelling and drawings development for the same.</div>
              <div>- Design for Extrusion and blow molding</div>
              <div>- GD&T analysis and tolerance stackup analysis for the assembly.</div>
              <div>- Mold design and development with collaboration with vendors</div>
              <div>- Collaboration with team for design improvement and cost optimization</div>
              <div>- Working with vendors for manufacturing the parts</div>
              <div>- Product verification and validation</div>
              <div>- 3D printing of the initial test samples</div>

              <b> <p>Skills</p>  </b>
               
              <div>- Knowledge of plastic materials, properties and manufacturing processes</div>
              <div>- Experience in design of plastic for Injection molding and Blow molding.</div>
              <div>- Experience in cost optimization through design preferred.</div>
              <div>- Experience in Mold design</div>
              <div>- Experience in GD&T and Tolerance Analysis for assembly</div>
              <div>- Experience in Design for 3D printing</div>
              <div>- Experience in Concept development, 3D modelling and drawings creation as per the drawings standards.</div>
              <div>- Strong communication skills and ability to work with team</div>

              <b><p>Desirable</p>  </b> 


             <div>Minimum of 5 years experience in plastic design and in new product development</div>
              <div>- Experience in product verification and validation processes.</div>
              <div>- Expert in Failure mode effect and criticality analysis for the design.</div>
              <div>- Experience in user needs and performance requirements for the product.</div>
              <div>- B.E/B.Tech or M.Tech in Mechanical engineering or any other relavant degree.</div>
              
               <b><p>Benefits</p>  </b>
              
              <div>- Work from anywhere.</div>
              <div>- Get profit % in this project.</div>
              <div>- You can work part-time, if you are associated with other organisation fulltime.</div>
              <div>- Work with true innovators.</div>

              <b><p>About Us</p></b>
              <div>Project Untouched is initiative of soaron.</div>
              <div>We develop innovative touchless products of the future that solves mankind's problems.</div>
                   
                  
              </div>
            <label htmlFor="check3">Read more</label>
            </div>
          </div>


        {/* ----- */}
      {/* --4th-- */}
      <div  style={{backgroundColor:'white'}} className='show__container'>
            <div  className="showb-1">
            <input type="checkbox" id='check4' />
            <div className="subshow">
               
                  <div className="subshow-1">
                  <div className='role__head'>Embedded Engineer</div>
                  
                    <div className='__loc'><b>Location</b>: Work from Anywhere </div>
                    <div className='ex'><b>Experience</b>: 0-1 year </div>
                    </div>
                    <div className="subshow-2">
                      <p><b>Date Posted</b>: <span>Jul 15,2022</span></p>
                      <a href="https://forms.gle/weZsTb2tdYV3K1xs7" target='_blank'><button   style={{cursor:'pointer'}} className='apply'>Apply</button></a>
                    </div>
              </div>
                  <div className="show__content">
                    <b><p>What we're looking for</p> </b>

                  <div>We are looking for an experienced Embedded Engineer to assist with the Electronics and testing of our "**Project Untouched**" products.
                  In this role, you will be working closely with the R&D team for the function of electronics, test existing electronic design,
                  and oversee the implementation of development projects.
                  You may also be spearheading the development of existing products.</div>

                  <div>To ensure success, you should have an experience as an embedded engineer, experience in battery system, and experience with
                  the core team. Top R&D engineers use their technical skills to create functional and
                  attractive products that are cost-effective and user-friendly.</div>

                  <b><p>Responsibilities</p></b>

                  <div>- Meeting with business, marketing, and the R&D team to discuss product ideas.</div>
                  <div>- Managing/Leading the electronics team.</div>
                  <div>- Redesigning existing circuit board or reduce costs.</div>
                  <div>- Testing circuits, sensor and other electronics.</div>
                  <div>- Overseeing the engineering of product prototypes.</div>
                  <div>- Testing prototype products for functionality, ease of use, and longevity.</div>
                  <div>- Resolving product issues.</div>
                  <div>- Overseeing the production process.</div>


                   <b><p>Requirements</p> </b>

                  <div>- Bachelor's degree in engineering, Electronics engineering, or relevant field.</div>
                  <div>- 3+ years  work experience in hardware design & development, schematic design, board design, digital and analog electronics</div>
                  <div>- Experience in PCB designing by using the software like KiCAD/EagleCAD.</div>
                  <div>- In-depth knowledge of electrical engineering.</div>
                  <div>- Experience in Embedded C & Python programming.</div>
                  <div>- Familiar with the programming of Arduino & Raspberry Pi.</div>
                  <div>- Knowledge in Communication Protocols like UART, SPI & I2C etc</div>
                  <div>- Strong Knowledge in Sensor & Actuators.</div>
                  <div>- Hands-on experience in soldering.</div>
                  <div> - Excellent communication skills.</div>
                  <div>- Experience with project management will add advantage.</div>

                   <b><p>Benefits</p>  </b>

                  <div>- Work from anywhere.</div>
                  <div>- Get profit % in this project.</div>
                  <div>- You can work part-time, if you are associated with other organisation fulltime.</div>
                  <div>- Work with true innovators.</div>

                 <b> <p>About Us</p> </b>

                  <div>Project Untouched is initiative of soaron.</div>
                  <div>We develop innovative touchless products of the future that solves mankind's problems.</div>

                   
                  
              </div>
            <label htmlFor="check4">Read more</label>
            </div>
          </div>

      {/*  */}

      {/* 5th */}
      <div  style={{backgroundColor:'#F1F1F1'}} className='show__container'>
            <div  className="showb-1">
            <input type="checkbox" id='check5' />
            <div className="subshow">
               
                  <div className="subshow-1">
                  <div className='role__head'>Sales Intern</div>
                  
                    <div className='__loc'><b>Location</b>: Work from Anywhere </div>
                    <div className='ex'><b>Experience</b>: 0-1 year </div>
                    </div>
                    <div className="subshow-2">
                      <p><b>Date Posted</b>: <span>Jul 15,2022</span></p>
                      <a href="https://forms.gle/weZsTb2tdYV3K1xs7" target='_blank'><button  style={{cursor:'pointer'}} className='apply'>Apply</button></a>
                    </div>
              </div>
                  <div className="show__content">
                  <b><p>We are looking for</p> </b>
                  <div>Candidates who have convincing, talkative attitude.</div> 
           
           <b><p>Responsibilities</p> </b>
           <div>- Collecting targeted customer data based on location.</div>
           <div>- Getting the pre-orders from the targeted customer both remotely and physically (depends on type of customers).</div>
           <div>- Until we deliver the product, you have to engage with the customer and have to update the delivery date.</div>
           <div>- Creating the sales strategy with respect to the product price along with the marketing & product team.</div>
           <div>- Achieve the sales target set for the territory, as per the company's need.</div>
           <div>- Should be open to travel / not shy away from field sales.</div>
           <div>- Should have your own 2 wheeler (fuel charges will be provided by organisation).</div>


           <b><p>Skills & Qualifications</p>   </b>

           <div>- Bachelor's degree required.</div>
           <div>- 2021 passed out only.</div>
           <div>- Strong and demonstrated written and verbal communications skills.</div>
           <div>- Negotiation & Persuasion skills.</div>
           <div>- You should know English, Hindi & Telugu.</div>
           <div>- People from Hyderabad are preferable.</div>
           <div>- Are available for a duration of 9 weeks (45 working days)</div>


          <b><p>Benefits</p>   </b>

           <div>- Work from anywhere.</div>
           <div>- Internship certificate.</div>
           <div>- Letter of recommendation.</div>
           <div>- Can be offered a full-time role depending on performance.</div>
           <div>- A bonus will be awarded based on your performance.</div>
           <div>- Work with true innovators.</div>

            <b><p>About Us</p>   </b>

           <div>Project Untouched is initiative of soaron.</div>

           <div>We develop innovative touchless products of the future that solves mankind's problems.</div>

                   
                  
              </div>
            <label htmlFor="check5">Read more</label>
            </div>
          </div>

      {/*  */}























        {/* -------------------------------------------- */}
{/*         
        <Accordion sx={{marginBottom:2}} elevation={0} expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{stroke: 'black', strokeWidth: 2}} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography  style={{fontSize:'0.9rem'}}><span className="number">01</span>&nbsp;&nbsp;<b style={{fontWeight:900}}>Mechanical Engineering Intern</b></Typography>
          </AccordionSummary>
          
          <AccordionDetails   style={{backgroundColor:'#EDEDED'}} >
            <Typography style={{fontSize:'0.75rem',fontWeight:900,opacity:0.66}}>
                
               

               <p>Untouched is hiring for Mechanical Engineering (Intern).</p> 

               <p> Responsibilities </p>
                 
               <div>- Prepare the calculation each during the product design & development stages.</div>
                <div>- Proper documentation of completed work.</div>
                <div>- Taking the initiatives during each stage of development.</div>
                <div>- You will be managing vendors.</div>
                <div>- You will be contributing your time in designing by using CAD Designing Software (Preferable Fusion 360).</div>
                <div>- You will also work on managing procurement.</div>
                <div>- You will be Assisting our Technical Team. </div>

                <p>Other Skills</p> 

                <div>- Fluency in English and Local Language.</div> 
                <div>- Good Communication Skills both written and verbal.</div> 
                <div>- Time Management Skills.</div> 
                <div>- Ability to accept radical decisions.</div> 
                <div>- Should be a quick learner.</div> 

                <p>Qualifications</p> 
                <div>- Graduated Bachelor's Degree (B.E/B.Tech) in Mechanical engineering or equivalent qualification.</div>
                <div>- Experience in using CAD Software (preferable Fusion 360).</div>
                <div>- Willingness to learn quickly in a self-paced training program.</div>
                <div>- Ability to read and draw mechanical drawings.</div>
                <div>- Knowledge in Manufacturing</div>

               <p>Benefits</p> 

                <div>- Work from anywhere.</div>
                <div>- Get profit % in this project.</div>
                <div>- You can work part-time, if you are associated with other organisation fulltime.</div>
                <div>- Work with true innovators.</div>

                <p>About Us</p> 
                
               <div>Project Untouched is initiative of soaron.</div>

                <div>We develop innovative touchless products of the future that solves mankind's problems.</div> 
                
               <p>How to Apply</p> 

                <div>Does this role sound like a good fit? Email us at career@soaron.co</div> 

               <p>- Include the role's title in your subject line.</p> 
                <p>-Send along links that best showcase the relevant things you've built and done.</p>  
                </Typography>
                
          </AccordionDetails>
          </Accordion>
        <Accordion sx={{marginBottom:2}} elevation={0} expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{stroke: 'black', strokeWidth: 2}} />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography  style={{fontSize:'0.9rem'}}><span className="number">02</span>&nbsp;&nbsp;<b style={{fontWeight:900}}>Electronics Engineer Intern</b></Typography>
          </AccordionSummary>
          
          <AccordionDetails   style={{backgroundColor:'#EDEDED'}} >
            <Typography style={{fontSize:'0.75rem',fontWeight:900,opacity:0.66}}>
                

                  <div>Untouched is hiring for Electronics Engineer (Intern).</div>

                  <p>Responsibilities</p>

                  <div>- Create block diagrams, identify the components, build & test the circuits.</div>
                  <div>- Prepare the calculation each during the circuit design & development stages.</div>
                  <div>- Proper documentation of completed work.</div>
                  <div>- Taking the initiatives during each stage of development.</div>

                  <p>Key Skills</p>

                  <div>- Strong knowledge of basic electronics.</div>
                  <div>- Should know the circuit design.</div>
                  <div>- Knowledge in PCB design software like Eagle & KICAD</div>
                  <div>- Should know Embedded C</div>
                  <div>- Familiar with the programming of Arduino & Raspberry Pi</div>
                  <div>- Knowledge in Python Programming added advantage</div>
                  <div>- Knowledge in Communication Protocols like UART, SPI & I2C etc</div>
                  <div>- Knowledge in Sensor & Actuators</div>
                  <div>- Hands-on experience in soldering.</div>

                 <p>Benefits</p> 

                  <div>- Work from anywhere.</div>
                  <div>- Get profit % in this project.</div>
                  <div>- You can work part-time, if you are associated with other organisation fulltime.</div>
                  <div>- Work with true innovators.</div>

                  <p>About Us</p>

                  <div>Project Untouched is initiative of soaron.</div>

                  <div>We develop innovative touchless products of the future that solves mankind's problems.</div>

                  <p>How to Apply</p>

                  <div>Does this role sound like a good fit? Email us at career@soaron.co</div>

                  <div>- Include the role's title in your subject line.</div>
                  <div>- Send along links that best showcase the relevant things you've built and done.</div>

                  <div>Duration: 3 months</div>

                  <div>Pay: 5000-10,000 (Based on policy of soaron)</div>

                  <div>Location: Hyderabad & WFH/Remote</div>

                  <div>Qualification: EEE/ECE, B.E/B.Tech</div>

                  <div>Pass-out year: 2021 only</div>
                                
                </Typography>
          </AccordionDetails>
          </Accordion>
        <Accordion sx={{marginBottom:2}} elevation={0} expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{stroke: 'black', strokeWidth: 2}} />}
            aria-controls="panel3a-content"
            id="panel3a-header"
          >
            <Typography  style={{fontSize:'0.9rem'}}><span className="number">03</span>&nbsp;&nbsp;<b style={{fontWeight:900}}>Design Engineer (Plastics)</b> </Typography>
          </AccordionSummary>
          
          <AccordionDetails   style={{backgroundColor:'#EDEDED'}} >
            <Typography style={{fontSize:'0.75rem',fontWeight:900,opacity:0.66}}>
             

              <div>Untouched is hiring for Plastic Design Engineer.</div>

              <p>Responsibilities</p> 

              <div>- Plastic parts modelling and drawings development for the same.</div>
              <div>- Design for Extrusion and blow molding</div>
              <div>- GD&T analysis and tolerance stackup analysis for the assembly.</div>
              <div>- Mold design and development with collaboration with vendors</div>
              <div>- Collaboration with team for design improvement and cost optimization</div>
              <div>- Working with vendors for manufacturing the parts</div>
              <div>- Product verification and validation</div>
              <div>- 3D printing of the initial test samples</div>

              <p>Skills</p> 
               
              <div>- Knowledge of plastic materials, properties and manufacturing processes</div>
              <div>- Experience in design of plastic for Injection molding and Blow molding.</div>
              <div>- Experience in cost optimization through design preferred.</div>
              <div>- Experience in Mold design</div>
              <div>- Experience in GD&T and Tolerance Analysis for assembly</div>
              <div>- Experience in Design for 3D printing</div>
              <div>- Experience in Concept development, 3D modelling and drawings creation as per the drawings standards.</div>
              <div>- Strong communication skills and ability to work with team</div>

             <p>Desirable</p> 


             <div>Minimum of 5 years experience in plastic design and in new product development</div>
              <div>- Experience in product verification and validation processes.</div>
              <div>- Expert in Failure mode effect and criticality analysis for the design.</div>
              <div>- Experience in user needs and performance requirements for the product.</div>
              <div>- B.E/B.Tech or M.Tech in Mechanical engineering or any other relavant degree.</div>
              
              <p>Benefits</p>
              
              <div>- Work from anywhere.</div>
              <div>- Get profit % in this project.</div>
              <div>- You can work part-time, if you are associated with other organisation fulltime.</div>
              <div>- Work with true innovators.</div>

              <p>About Us</p>
              <div>Project Untouched is initiative of soaron.</div>
              <div>We develop innovative touchless products of the future that solves mankind's problems.</div>

              <p>How to Apply</p> 

              <div>Does this role sound like a good fit? Email us at career@soaron.co</div>

              <div>- Include the role's title in your subject line.</div>
              <div>- Send along links that best showcase the relevant things you've built and done.</div>
                              
                </Typography>
          </AccordionDetails>
          </Accordion>
        <Accordion sx={{marginBottom:2}} elevation={0} expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{stroke: 'black', strokeWidth: 2}} />}
            aria-controls="panel4a-content"
            id="panel4a-header"
          >
            <Typography  style={{fontSize:'0.9rem'}}><span className="number">04</span>&nbsp;&nbsp;<b style={{fontWeight:900}}>Embedded Engineer</b></Typography>
          </AccordionSummary>
          
          <AccordionDetails   style={{backgroundColor:'#EDEDED'}} >
            <Typography style={{fontSize:'0.75rem',fontWeight:900,opacity:0.66}}>
                
           

               <div>Untouched is hiring for Embedded Engineer.</div> 

                <p>What we're looking for</p>

                <div>We are looking for an experienced Embedded Engineer to assist with the Electronics and testing of our "**Project Untouched**" products.
                In this role, you will be working closely with the R&D team for the function of electronics, test existing electronic design,
                and oversee the implementation of development projects.
                You may also be spearheading the development of existing products.</div>

                <div>To ensure success, you should have an experience as an embedded engineer, experience in battery system, and experience with
                the core team. Top R&D engineers use their technical skills to create functional and
                attractive products that are cost-effective and user-friendly.</div>

                <p>Responsibilities</p> 
                <div>- Meeting with business, marketing, and the R&D team to discuss product ideas.</div>
                <div>- Managing/Leading the electronics team.</div>
                <div>- Redesigning existing circuit board or reduce costs.</div>
                <div>- Testing circuits, sensor and other electronics.</div>
                <div>- Overseeing the engineering of product prototypes.</div>
                <div>- Testing prototype products for functionality, ease of use, and longevity.</div>
                <div>- Resolving product issues.</div>
                <div>- Overseeing the production process.</div>
                

                <p>Requirements</p>
                <div>- Bachelor's degree in engineering, Electronics engineering, or relevant field.</div>
                <div>- 3+ years  work experience in hardware design & development, schematic design, board design, digital and analog electronics</div>
                <div>- Experience in PCB designing by using the software like KiCAD/EagleCAD.</div>
                <div>- In-depth knowledge of electrical engineering.</div>
                <div>- Experience in Embedded C & Python programming.</div>
                <div>- Familiar with the programming of Arduino & Raspberry Pi.</div>
                <div>- Knowledge in Communication Protocols like UART, SPI & I2C etc</div>
                <div>- Strong Knowledge in Sensor & Actuators.</div>
                <div>- Hands-on experience in soldering.</div>
                <div> - Excellent communication skills.</div>
                <div>- Experience with project management will add advantage.</div>

                <p>Benefits</p>
              
                <div>- Work from anywhere.</div>
                <div>- Get profit % in this project.</div>
                <div>- You can work part-time, if you are associated with other organisation fulltime.</div>
                <div>- Work with true innovators.</div>

                <p>About Us</p>
                <div>Project Untouched is initiative of soaron.</div>
                <div>We develop innovative touchless products of the future that solves mankind's problems.</div>

                <p>How to Apply</p> 

                <div>Does this role sound like a good fit? Email us at career@soaron.co</div>

                <div>- Include the role's title in your subject line.</div>
                <div>- Send along links that best showcase the relevant things you've built and done.</div>

                 
                </Typography>
          </AccordionDetails>
          </Accordion>
        <Accordion sx={{marginBottom:2}} elevation={0} expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{stroke: 'black', strokeWidth: 2}} />}
            aria-controls="panel5a-content"
            id="panel5a-header"
          >
            <Typography  style={{fontSize:'0.9rem'}}><span className="number">05</span>&nbsp;&nbsp;<b style={{fontWeight:900}}>Sales Intern</b></Typography>
          </AccordionSummary>
          
          <AccordionDetails   style={{backgroundColor:'#EDEDED'}} >
            <Typography style={{fontSize:'0.75rem',fontWeight:900,opacity:0.66}}>
              <div> We are looking for the candidates who have convincing, talkative attitude.</div>
           
            <p>Responsibilities</p>
            <div>- Collecting targeted customer data based on location.</div>
            <div>- Getting the pre-orders from the targeted customer both remotely and physically (depends on type of customers).</div>
            <div>- Until we deliver the product, you have to engage with the customer and have to update the delivery date.</div>
            <div>- Creating the sales strategy with respect to the product price along with the marketing & product team.</div>
            <div>- Achieve the sales target set for the territory, as per the company's need.</div>
            <div>- Should be open to travel / not shy away from field sales.</div>
            <div>- Should have your own 2 wheeler (fuel charges will be provided by organisation).</div>


            <p>Skills & Qualifications</p>

            <div>- Bachelor's degree required.</div>
            <div>- 2021 passed out only.</div>
            <div>- Strong and demonstrated written and verbal communications skills.</div>
            <div>- Negotiation & Persuasion skills.</div>
            <div>- You should know English, Hindi & Telugu.</div>
            <div>- People from Hyderabad are preferable.</div>
            <div>- Are available for a duration of 9 weeks (45 working days)</div>


          <p>Benefits</p> 

            <div>- Work from anywhere.</div>
            <div>- Internship certificate.</div>
            <div>- Letter of recommendation.</div>
            <div>- Can be offered a full-time role depending on performance.</div>
            <div>- A bonus will be awarded based on your performance.</div>
            <div>- Work with true innovators.</div>

            <p>About Us</p>

            <div>Project Untouched is initiative of soaron.</div>

            <div>We develop innovative touchless products of the future that solves mankind's problems.</div>  <p>What we're looking for</p>
            
            

            <p>How to Apply</p>

            <div>Does this role sound like a good fit? Fill [this] (https://forms.gle/WHfEUuJXJT56SVDSA) form or Email your resume us at career@soaron.co</div>

            <div>- Include the role's title in your subject line.</div>
            <div>- Send along links that best showcase the relevant things you've built and done.</div>
                
            </Typography>
          </AccordionDetails>
          </Accordion> */}
        </div>
        );
    }